import CustomButton from "@/_components/CustomButton"
import { getUriAndCacheResponse } from "@/_services/cache"
import React from "react"
import { Image, Modal } from "react-bootstrap"

export default function ImageZoomModal({ id, name, src, onHide }) {
  return (
    <Modal show={true} bsSize="xl" onHide={onHide} className="images-card-modal">
      <Modal.Header closeButton>
        <Modal.Title>{name}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ display: "flex", justifyContent: "center" }}>
        <Image responsive id={id} src={src} alt={name} />
      </Modal.Body>

      <Modal.Footer>
        <CustomButton bsSize="sm" label="Close" onClick={onHide} />
      </Modal.Footer>
    </Modal>
  )
}

// Images in links keep opening their link
export async function getZoomedImage(event) {
  const img = event.target.closest("img")
  if (!img || img.closest("a")) return

  // A document image is shown from a blob URL freed once loaded (see tokenUrls.js): the document is loaded again
  const { documentName, documentSrc } = img.dataset
  const src = documentSrc ? await getUriAndCacheResponse(`${documentSrc}?withMimeType=1&base64=1`) : img.src
  return { name: documentName || img.alt, src }
}
